import { BulletResults } from '../BulletResults/BulletResults'
import { insightTabs } from '../../Insights'
import { VisualizeTree } from '../VisualizeTree/VisualizeTree'
import { InfoIcon, ShareIcon } from '@phosphor-icons/react'
import { ScoopGrid, ScoopTooltip, ScoopButton, ScoopText } from '../../../../ui'
import styles from './GroupAnalysisResult.module.scss'

export const GroupAnalysisResult = ({
    mlResults,
    selectedTab,
    setSelectedTab,
    setMlResults,
    mlConfig,
    setMlConfig,
}) => {
    const handleOpenInStudio = () => {
        if (setSelectedTab) {
            setSelectedTab(insightTabs[1].key)
            setMlResults(mlResults)
            mlConfig.dateToUSe = mlResults.filterDate
            mlConfig.modelType = 'cluster'
            if (mlResults.filter) {
                mlConfig.filter = mlResults.filter
                mlConfig.filterDescription = mlResults.filterDescription
            }
            setMlConfig({ ...mlConfig })
        }
    }
    let option = null

    return (
        <>
            {mlResults && mlResults.error && (
                <div className={styles.errorContainer}>
                    <BulletResults mlResults={mlResults} />
                </div>
            )}
            {mlResults && mlResults.numInstances && mlResults.groupOne && mlResults.groupTwo && (
                <div className={styles.resultsContainer}>
                    <ScoopGrid container gap={16} className={styles.gridContainer}>
                        <ScoopGrid item xs={11}>
                            <ScoopText variant="h2" className={styles.title}>
                                Group Analysis
                                <ScoopTooltip title="Group analysis compares two different groups within your dataset defined by different filters. It attempts to find the key differences by analyzing what truly makes them unique and then summarizing the results.">
                                    <InfoIcon size={14} className={styles.superAlign} />
                                </ScoopTooltip>
                            </ScoopText>
                        </ScoopGrid>
                        <ScoopGrid item xs={1}>
                            {selectedTab === insightTabs[0].key && (
                                <ScoopTooltip title={'Open in Data Science Discovery Studio'}>
                                    <ScoopButton variant="icon" onClick={handleOpenInStudio}>
                                        <ShareIcon size={20} />
                                    </ScoopButton>
                                </ScoopTooltip>
                            )}
                        </ScoopGrid>
                        <ScoopGrid item xs={12}>
                            <ScoopText className={styles.subtitle}>
                                Comparing the {mlResults.groupOne?.name} Group
                                <ScoopTooltip
                                    title={
                                        'This group satisfies the filter condition: ' +
                                        mlResults.groupOne?.filterDescription
                                    }
                                >
                                    <InfoIcon size={14} className={styles.superAlign} />
                                </ScoopTooltip>
                                &nbsp;to the {mlResults.groupTwo?.name} Group
                                <ScoopTooltip
                                    title={
                                        'This group satisfies the filter condition: ' +
                                        mlResults.groupTwo?.filterDescription
                                    }
                                >
                                    <InfoIcon size={14} className={styles.superAlign} />
                                </ScoopTooltip>
                            </ScoopText>
                        </ScoopGrid>
                        <ScoopGrid item xs={2} className={styles.metadataBox}>
                            <div>
                                <strong>Data rows:</strong>{' '}
                                {(mlResults.numInstances ?? 0).toLocaleString()}
                            </div>
                        </ScoopGrid>
                        <ScoopGrid item xs={10} rowspan={2} className={styles.metadataBox}>
                            <div>
                                <strong>Columns used:</strong>
                                &nbsp;
                                {mlResults?.columns.map((col) => col.name).join(', ')}
                                <ScoopTooltip title="From highest signifance to lowest">
                                    <InfoIcon size={14} className={styles.superAlign} />
                                </ScoopTooltip>
                            </div>
                            {mlResults?.filterDescription && (
                                <div>
                                    <strong>Filters:</strong>&nbsp;{mlResults?.filterDescription}
                                </div>
                            )}
                        </ScoopGrid>
                        {mlResults.graph && (
                            <ScoopGrid item xs={12} className={styles.treeSection}>
                                <VisualizeTree graph={mlResults.graph} />
                            </ScoopGrid>
                        )}
                        <ScoopGrid item xs={12} className={styles.bulletSection}>
                            <BulletResults mlResults={mlResults} />
                        </ScoopGrid>
                    </ScoopGrid>
                </div>
            )}
        </>
    )
}
